module.exports = __webpack_public_path__ + "static/media/Neutral.d9e4307b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neutral.svg
// module id = 306
// module chunks = 0